/* global axios */

// CAIXA DE NOTIFICAÇÕES (2026-08-09, Lote 2).
//
// Fila ÚNICA: a resposta já vem com as duas fontes intercaladas — a nossa (tarefa de CRM
// vencida, nota-tarefa vencida) e a do Chatwoot (conversa atribuída, menção, SLA). O
// frontend não sabe nem precisa saber de onde cada linha veio; quem junta é o
// NotificationReader no servidor.
//
// ⚠️ A CHAVE É COMPOSTA — "cw:7" ou "core:7", nunca um número. Os ids das duas tabelas
// colidem, e mandar `7` faria o servidor marcar como lida uma notificação de outra fonte.
// Sempre devolva a `chave` que veio no payload, sem fatiar.
const base = accountId => `/api/v1/accounts/${accountId}/cw_custom`;

export default {
  // { notifications: [...], unread_count: n }
  fetchNotifications(accountId) {
    return axios.get(`${base(accountId)}/crm_notifications`);
  },

  // { unread_count: n } — o contador volta na resposta de propósito, para o badge não
  // precisar de uma segunda chamada e nunca discordar da lista.
  markRead(accountId, chave) {
    return axios.post(`${base(accountId)}/crm_notifications/read`, { chave });
  },

  markAllRead(accountId) {
    return axios.post(`${base(accountId)}/crm_notifications/read_all`);
  },
};
